import React from 'react';
import { BodyText } from "@hm-group/fabric-components/components/Typography";
import cn from 'classnames';
import "./ProductMarkers.css";
var styles = { "marketingMarkers": "d9a1e5", "hm": "a5bd17", "northstar-small": "b4a4bd", "northstar-large": "b8016c" };
const ProductMarkers = ({ markers = [], selection, variant = 'hm' }) => {
    if (!markers.length && !selection)
        return null;
    return (React.createElement(React.Fragment, null,
        markers.map((marker) => (React.createElement(BodyText, { Tag: "span", key: marker.text, hasEllipsis: true, className: cn(styles.marketingMarkers, styles[variant]) }, marker.text))),
        selection && (React.createElement(BodyText, { Tag: "span", hasEllipsis: true, className: cn(styles.marketingMarkers, styles[variant]) }, selection))));
};
export default ProductMarkers;
//# sourceMappingURL=ProductMarkers.js.map